import Resource from '@/api/resources/Resource'

class SampleDiagnosisAttachmentService extends Resource {
    async addAttachment(laboratoryId, caseId, sampleId, request) {
        const response = await this.axios.post(
            `/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/diagnosis/attachments`,
            request)
        return response.data
    }

    async getAttachments(laboratoryId, caseId, sampleId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/diagnosis/attachments`)
        return response.data
    }

    async deleteAttachment(laboratoryId, caseId, sampleId, descriptionAttachmentId) {
        const response = await this.axios.delete(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/diagnosis/attachments/${descriptionAttachmentId}`)
        return response.data
    }
}

export default new SampleDiagnosisAttachmentService()
